module.exports = __webpack_public_path__ + "img/writingSeminar_041022_D.8eb17b27.jpg";